import React from "react";
import "./MutualSip.css";

const mutualData = [
  {
    title: "Mutual Funds",
    text:
      "Mutual funds are investment instruments where money is pooled from multiple investors and invested in a diversified portfolio of equities, bonds, or other securities, managed by professional fund managers. They help investors grow wealth over time while spreading risk and offering flexibility based on individual financial goals.",
    icon: "/icons/z7.png"
  },
  {
    title: "SIP",
    text:
      "A Systematic Investment Plan (SIP) is a disciplined way of investing in mutual funds, where a fixed amount is invested regularly (monthly or quarterly). SIP helps investors build long-term wealth by averaging market costs and benefiting from the power of compounding.",
    icon: "/icons/z12.png"
  }
];

export default function MutualSip() {
  return (
    <section className="mutual-section" id="mutual">
      <h2 className="mutual-heading">Mutual Funds & SIP</h2>

      <div className="mutual-grid">
        {mutualData.map((item, index) => (
          <div className="mutual-card" key={index}>
            <img src={item.icon} alt={item.title} className="card-icon" />
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
